import styled from 'styled-components';

import { Text } from '../../../../components';
import { COLORS, SPACE } from '../../../../theme/tokens';

export const Head = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${SPACE[12]};
  flex-wrap: wrap;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[12]};
  margin-top: ${SPACE[16]};
`;

export const TagRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACE[8]};
  flex-wrap: wrap;
`;

/** Where the shown text comes from ("Now showing the text from /casino/*"). */
export const SourceTag = styled(Text)`
  font-size: 13px;
  color: ${COLORS.textMuted};
`;

export const Note = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textMuted};
`;

export const HintText = styled(Text)`
  font-size: 12px;
  color: ${COLORS.warning};
`;

export const ErrorText = styled(Text)`
  font-size: 12px;
  color: ${COLORS.danger};
`;
